import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import Dropdown from "../common/Dropdown";
import DropdownMenu from "../FormComponents/DropdownMenu";
import DateRangeInput from "../FormComponents/DateRangeInput";
import { format } from "date-fns";
import { parseLocalDate } from "../../utils/dateTime";
import { getLogicOptions } from "./constants";
import { useEffect, useRef, useState } from "react";
import { t } from "i18next";
import SingleDateInput from "../FormComponents/SingleDateInput";
var getCommonInputClasses = function getCommonInputClasses(textColor, borderColor) {
  var baseClasses = ["block", "w-full", "rounded-md", "text-[12px]", "px-2", "py-1", "bg-gray-200", "dark:bg-transparent", "!border", "pb-2", "text-left", "focus:outline-none", "focus:ring-2", "focus:ring-teal-500", "disabled:opacity-60", "disabled:cursor-not-allowed"];

  // Add text color classes
  if (textColor) {
    baseClasses.push(textColor);
  } else {
    baseClasses.push("text-gray-800", "dark:text-gray-200");
  }

  // Add border color classes
  if (borderColor) {
    baseClasses.push(borderColor);
  } else {
    baseClasses.push("!border-gray-500", "dark:border-gray-500");
  }
  return baseClasses.join(" ");
};
export var TagInput = function TagInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    field = _ref.field,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$inputClassName = _ref.inputClassName,
    inputClassName = _ref$inputClassName === void 0 ? "" : _ref$inputClassName,
    disabled = _ref.disabled,
    textColor = _ref.textColor,
    borderColor = _ref.borderColor,
    sectionColor = _ref.sectionColor,
    isLC = _ref.isLC;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;

  // Only apply section color as inline style if borderColor prop is provided (indicating we want section colors)
  var borderStyle = borderColor && sectionColor && !isLC ? {
    borderColor: sectionColor
  } : {};
  return /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: value || "",
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    className: "".concat(getCommonInputClasses(textColor, borderColor), " ").concat(className, " ").concat(inputClassName),
    style: borderStyle,
    disabled: isDisabled
  });
};
export var TagNumberInput = function TagNumberInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    field = _ref2.field,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    _ref2$inputClassName = _ref2.inputClassName,
    inputClassName = _ref2$inputClassName === void 0 ? "" : _ref2$inputClassName,
    disabled = _ref2.disabled,
    textColor = _ref2.textColor,
    borderColor = _ref2.borderColor,
    sectionColor = _ref2.sectionColor,
    isLC = _ref2.isLC;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;

  // Only apply section color as inline style if borderColor prop is provided (indicating we want section colors)
  var borderStyle = borderColor && sectionColor && !isLC ? {
    borderColor: sectionColor
  } : {};
  var handleChange = function handleChange(e) {
    var inputValue = e.target.value;
    // For integer type, remove any decimal points and everything after it
    if (field.tag_type === "integer") {
      var integerValue = inputValue.split(".")[0];
      onChange(integerValue);
      return;
    }
    onChange(inputValue);
  };
  return /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value !== null && value !== void 0 ? value : "",
    onChange: handleChange,
    onKeyDown: function onKeyDown(e) {
      if (field.tag_type === "integer" && (e.key === "." || e.key === ",")) {
        e.preventDefault();
      }
    },
    className: "".concat(getCommonInputClasses(textColor, borderColor), " ").concat(className, " ").concat(inputClassName),
    style: borderStyle,
    disabled: isDisabled,
    step: field.tag_type === "float" ? "0.1" : "1"
  });
};
export var TagDateInput = function TagDateInput(_ref3) {
  var value = _ref3.value,
    _onChange2 = _ref3.onChange,
    field = _ref3.field,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? "" : _ref3$className,
    _ref3$inputClassName = _ref3.inputClassName,
    inputClassName = _ref3$inputClassName === void 0 ? "" : _ref3$inputClassName,
    disabled = _ref3.disabled,
    textColor = _ref3.textColor,
    borderColor = _ref3.borderColor,
    sectionColor = _ref3.sectionColor,
    isLC = _ref3.isLC;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  // Only apply section color as inline style if borderColor prop is provided (indicating we want section colors)
  var borderStyle = borderColor && sectionColor && !isLC ? {
    borderColor: sectionColor
  } : {};
  var toLocalDate = function toLocalDate(dateValue) {
    if (!dateValue) return null;
    try {
      if (typeof dateValue === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        return parseLocalDate(dateValue);
      }
      var date = new Date(dateValue);
      if (isNaN(date.getTime())) return null;
      // Normalise to local midnight so the picker always shows the correct day.
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    } catch (_unused) {
      return null;
    }
  };
  return /*#__PURE__*/React.createElement(SingleDateInput, {
    placeholder: t("select_date"),
    value: toLocalDate(value),
    onChange: function onChange(val) {
      return _onChange2(val);
    },
    inputFormat: "MMM DD, YYYY",
    classNames: "[&_input]:!bg-gray-200 [&_input]:!text-[#11181C] dark:[&_input]:!bg-gray-800 dark:[&_input]:!text-gray-100",
    tooltip: t("select_date"),
    dayStyle: null,
    highlightToday: true,
    options: {
      withinPortal: true,
      zIndex: 1000
    }
  });
};
export var TagRadioInput = function TagRadioInput(_ref4) {
  var _field$properties;
  var value = _ref4.value,
    _onChange3 = _ref4.onChange,
    field = _ref4.field,
    _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? "" : _ref4$className,
    _ref4$inputClassName = _ref4.inputClassName,
    inputClassName = _ref4$inputClassName === void 0 ? "" : _ref4$inputClassName,
    disabled = _ref4.disabled,
    sectionColor = _ref4.sectionColor;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  var options = Array.isArray((_field$properties = field.properties) === null || _field$properties === void 0 ? void 0 : _field$properties.options) ? field.properties.options : [];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 ".concat(className)
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("label", {
      key: option,
      className: "flex items-center gap-1 ".concat(inputClassName)
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      checked: value === option,
      onChange: function onChange() {
        return _onChange3(option);
      },
      disabled: isDisabled
    }), option);
  }));
};
export var TagDropdownInput = function TagDropdownInput(_ref5) {
  var _field$properties2;
  var value = _ref5.value,
    _onChange4 = _ref5.onChange,
    field = _ref5.field,
    disabled = _ref5.disabled,
    _ref5$forceFullWidth = _ref5.forceFullWidth,
    forceFullWidth = _ref5$forceFullWidth === void 0 ? false : _ref5$forceFullWidth,
    borderColor = _ref5.borderColor,
    isLC = _ref5.isLC,
    _ref5$portal = _ref5.portal,
    portal = _ref5$portal === void 0 ? false : _ref5$portal,
    _ref5$optionsListClas = _ref5.optionsListClassName,
    optionsListClassName = _ref5$optionsListClas === void 0 ? "" : _ref5$optionsListClas,
    _ref5$hideSelectOptio = _ref5.hideSelectOption,
    hideSelectOption = _ref5$hideSelectOptio === void 0 ? false : _ref5$hideSelectOptio,
    _ref5$disableTruncate = _ref5.disableTruncate,
    disableTruncate = _ref5$disableTruncate === void 0 ? false : _ref5$disableTruncate;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  var isDeletable = !field.additional.isSystemField;
  var options = Array.isArray((_field$properties2 = field.properties) === null || _field$properties2 === void 0 ? void 0 : _field$properties2.options) ? field.properties.options : [];
  var formattedOptions = options.map(function (opt) {
    return {
      label: opt,
      value: opt
    };
  });
  var placeholderOption = {
    label: "Select...",
    value: ""
  };
  var allOptions = isDeletable && !hideSelectOption ? [placeholderOption].concat(_toConsumableArray(formattedOptions)) : formattedOptions;
  var selectedOption = allOptions.find(function (opt) {
    return opt.value === value;
  }) || placeholderOption;
  var _useOptionWidthCalcul = useOptionWidthCalculation(options, 128),
    maxOptionWidth = _useOptionWidthCalcul.maxOptionWidth,
    hiddenSpanRef = _useOptionWidthCalcul.hiddenSpanRef;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    style: !portal ? {
      width: forceFullWidth ? "100%" : maxOptionWidth > 0 ? "".concat(maxOptionWidth, "px") : undefined,
      minWidth: forceFullWidth ? "100%" : "128px" // Ensure minimum width
    } : {}
  }, /*#__PURE__*/React.createElement("span", {
    ref: hiddenSpanRef,
    className: "absolute invisible whitespace-nowrap text-[12px]",
    style: {
      fontFamily: "inherit"
    }
  }), /*#__PURE__*/React.createElement(Dropdown, {
    selectedOption: selectedOption,
    onChange: function onChange(option) {
      return _onChange4(option.value);
    },
    options: allOptions,
    disabled: isDisabled,
    isBottomAligned: true,
    hasBorder: true,
    className: "border w-full !px-2 !py-2 text-[12px] ".concat(borderColor && !isLC ? borderColor.replace("border-", "!border-") : "!border-gray-400"),
    menuClassName: optionsListClassName,
    portal: portal,
    disableTruncate: disableTruncate
  }));
};
export var TagMultiDropdownInput = function TagMultiDropdownInput(_ref6) {
  var _field$properties3;
  var value = _ref6.value,
    onChange = _ref6.onChange,
    field = _ref6.field,
    _ref6$optionsListClas = _ref6.optionsListClassName,
    optionsListClassName = _ref6$optionsListClas === void 0 ? "w-[225px] overflow-x-auto" : _ref6$optionsListClas,
    _ref6$showUserRolePil = _ref6.showUserRolePill,
    showUserRolePill = _ref6$showUserRolePil === void 0 ? false : _ref6$showUserRolePil,
    _ref6$title = _ref6.title,
    title = _ref6$title === void 0 ? "" : _ref6$title,
    disabled = _ref6.disabled,
    _ref6$forceFullWidth = _ref6.forceFullWidth,
    forceFullWidth = _ref6$forceFullWidth === void 0 ? false : _ref6$forceFullWidth,
    isLC = _ref6.isLC,
    borderColor = _ref6.borderColor,
    _ref6$buttonClassName = _ref6.buttonClassName,
    buttonClassName = _ref6$buttonClassName === void 0 ? "" : _ref6$buttonClassName,
    placeholder = _ref6.placeholder,
    _ref6$portal = _ref6.portal,
    portal = _ref6$portal === void 0 ? false : _ref6$portal;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  var options = Array.isArray((_field$properties3 = field.properties) === null || _field$properties3 === void 0 ? void 0 : _field$properties3.options) ? field.properties.options : [];

  // Normalize selectedValues to match options for checkmark display
  // Handle both scenarios:
  // 1. User selects values (already match options exactly)
  // 2. Values provided via props (may need normalization - whitespace, case, etc.)
  var selectedValues = Array.isArray(value) ? value.filter(function (opt) {
    return opt != null && opt !== "";
  }) // Remove null/empty values
  .map(function (opt) {
    var trimmed = String(opt).trim();
    // Try to find a match in options array (normalizing for comparison)
    // This handles cases where props values have extra whitespace or slight differences
    var matchedOption = options.find(function (o) {
      var optionTrimmed = String(o).trim();
      // Exact match or normalized match (case-sensitive for now, but handles whitespace)
      return o === opt || o === trimmed || optionTrimmed === trimmed;
    });
    // Return the exact option value if matched (for checkmark display)
    // Otherwise return the trimmed original value (to preserve data and show in button)
    return matchedOption || trimmed;
  }) : [];
  var _useOptionWidthCalcul2 = useOptionWidthCalculation(options, 150),
    maxOptionWidth = _useOptionWidthCalcul2.maxOptionWidth,
    hiddenSpanRef = _useOptionWidthCalcul2.hiddenSpanRef;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    title: title,
    style: !portal ? {
      width: forceFullWidth ? "100%" : maxOptionWidth > 0 ? "".concat(maxOptionWidth, "px") : undefined,
      minWidth: forceFullWidth ? "100%" : "150px" // Ensure minimum width
    } : {}
  }, /*#__PURE__*/React.createElement("span", {
    ref: hiddenSpanRef,
    className: "absolute invisible whitespace-nowrap text-[12px]",
    style: {
      fontFamily: "inherit"
    }
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    selectedOptions: selectedValues,
    onChange: onChange,
    options: options,
    placeholder: placeholder || t("label.select_options"),
    category: "",
    workspaceData: [],
    showAdminTagOnly: false,
    skipPermissionCheck: true,
    disabled: isDisabled,
    showUserRolePill: showUserRolePill,
    optionsListClassName: optionsListClassName,
    dropdownArrowColor: "#D9DBDD",
    dropdownArrowOpacity: 0.5,
    buttonClassName: buttonClassName || "!px-[4px] !py-[4px] !pr-5 !bg-transparent",
    portal: portal
  }));
};
export var TagBooleanInput = function TagBooleanInput(_ref7) {
  var value = _ref7.value,
    _onChange5 = _ref7.onChange,
    field = _ref7.field,
    _ref7$className = _ref7.className,
    className = _ref7$className === void 0 ? "" : _ref7$className,
    _ref7$inputClassName = _ref7.inputClassName,
    inputClassName = _ref7$inputClassName === void 0 ? "" : _ref7$inputClassName,
    disabled = _ref7.disabled,
    _ref7$forceFullWidth = _ref7.forceFullWidth,
    forceFullWidth = _ref7$forceFullWidth === void 0 ? false : _ref7$forceFullWidth,
    textColor = _ref7.textColor,
    borderColor = _ref7.borderColor,
    isLC = _ref7.isLC,
    _ref7$portal = _ref7.portal,
    portal = _ref7$portal === void 0 ? false : _ref7$portal,
    _ref7$hideSelectOptio = _ref7.hideSelectOption,
    hideSelectOption = _ref7$hideSelectOptio === void 0 ? false : _ref7$hideSelectOptio;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  var isDeletable = !field.additional.isSystemField;
  var options = [].concat(_toConsumableArray(isDeletable && !hideSelectOption ? [{
    label: t("select_key"),
    value: ""
  }] : []), [{
    label: t("yes_key"),
    value: "true"
  }, {
    label: t("no_key"),
    value: "false"
  }]);
  var selectedOption = value === true || value === "true" ? options.find(function (opt) {
    return opt.value === "true";
  }) || options[0] : value === false || value === "false" ? options.find(function (opt) {
    return opt.value === "false";
  }) || options[0] : portal ? null : options[0];
  return /*#__PURE__*/React.createElement("div", {
    className: portal ? "w-auto" : "w-full",
    style: {
      width: forceFullWidth ? "100%" : undefined,
      minWidth: forceFullWidth ? "100%" : undefined
    }
  }, /*#__PURE__*/React.createElement(Dropdown, {
    selectedOption: selectedOption,
    onChange: function onChange(option) {
      return _onChange5(option.value === "" ? undefined : option.value === "true");
    },
    options: options,
    disabled: isDisabled,
    isBottomAligned: true,
    hasBorder: true,
    className: "border text-[12px] w-full !px-2 !py-2 ".concat(borderColor && !isLC ? borderColor.replace("border-", "!border-") : "!border-gray-400"),
    menuClassName: "w-auto min-w-[128px]",
    portal: portal
  }));
};
export var TagUserInput = function TagUserInput(_ref8) {
  var _field$properties4;
  var value = _ref8.value,
    _onChange6 = _ref8.onChange,
    field = _ref8.field,
    _ref8$className = _ref8.className,
    className = _ref8$className === void 0 ? "" : _ref8$className,
    _ref8$inputClassName = _ref8.inputClassName,
    inputClassName = _ref8$inputClassName === void 0 ? "" : _ref8$inputClassName,
    disabled = _ref8.disabled,
    _ref8$forceFullWidth = _ref8.forceFullWidth,
    forceFullWidth = _ref8$forceFullWidth === void 0 ? false : _ref8$forceFullWidth,
    textColor = _ref8.textColor,
    borderColor = _ref8.borderColor,
    isLC = _ref8.isLC,
    _ref8$portal = _ref8.portal,
    portal = _ref8$portal === void 0 ? false : _ref8$portal,
    _ref8$hideSelectOptio = _ref8.hideSelectOption,
    hideSelectOption = _ref8$hideSelectOptio === void 0 ? false : _ref8$hideSelectOptio;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  var isDeletable = !field.additional.isSystemField;
  var options = Array.isArray((_field$properties4 = field.properties) === null || _field$properties4 === void 0 ? void 0 : _field$properties4.options) ? field.properties.options : [];
  var formattedOptions = options.map(function (opt) {
    return {
      label: opt,
      value: opt
    };
  });
  var placeholderOption = {
    label: t("label.select_user"),
    value: ""
  };
  var allOptions = isDeletable && !hideSelectOption ? [placeholderOption].concat(_toConsumableArray(formattedOptions)) : formattedOptions;
  var selectedOption = allOptions.find(function (opt) {
    return opt.value === value;
  }) || placeholderOption;
  return /*#__PURE__*/React.createElement("div", {
    className: portal ? "w-auto" : "w-full",
    style: {
      width: forceFullWidth ? "100%" : undefined,
      minWidth: forceFullWidth ? "100%" : undefined
    }
  }, /*#__PURE__*/React.createElement(Dropdown, {
    selectedOption: selectedOption,
    onChange: function onChange(option) {
      return _onChange6(option.value);
    },
    options: allOptions,
    disabled: isDisabled,
    isBottomAligned: true,
    hasBorder: true,
    className: "border w-full !px-2 !py-2 ".concat(className, " ").concat(inputClassName, " ").concat(borderColor && !isLC ? borderColor.replace("border-", "!border-") : "!border-gray-400", " ").concat(textColor ? textColor.replace(/\btext-/g, "!text-") : "!text-gray-800 dark:!text-gray-200"),
    portal: portal
  }));
};
export var TagNumberInputWithLogic = function TagNumberInputWithLogic(_ref9) {
  var value = _ref9.value,
    onChange = _ref9.onChange,
    field = _ref9.field,
    _ref9$className = _ref9.className,
    className = _ref9$className === void 0 ? "" : _ref9$className,
    _ref9$inputClassName = _ref9.inputClassName,
    inputClassName = _ref9$inputClassName === void 0 ? "" : _ref9$inputClassName,
    logic = _ref9.logic,
    onLogicChange = _ref9.onLogicChange,
    disabled = _ref9.disabled,
    textColor = _ref9.textColor,
    borderColor = _ref9.borderColor,
    isLC = _ref9.isLC;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  var comparisonOptions = getLogicOptions("number");
  var selectedLogicOption = comparisonOptions.find(function (opt) {
    return opt.value === logic;
  }) || comparisonOptions[0];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 w-full ".concat(className)
  }, /*#__PURE__*/React.createElement(Dropdown, {
    selectedOption: selectedLogicOption,
    onChange: function onChange(option) {
      return onLogicChange === null || onLogicChange === void 0 ? void 0 : onLogicChange(option.value);
    },
    options: comparisonOptions,
    disabled: isDisabled,
    isBottomAligned: true,
    hasBorder: true,
    className: "border min-w-[80px] !px-2 !py-2 ".concat(borderColor && !isLC ? borderColor.replace("border-", "!border-") : "!border-gray-400")
  }), /*#__PURE__*/React.createElement("div", {
    className: !logic ? "opacity-50 pointer-events-none" : ""
  }, /*#__PURE__*/React.createElement(TagNumberInput, {
    value: value,
    onChange: onChange,
    field: field,
    className: inputClassName,
    disabled: isDisabled
  })));
};
export var TagDateInputWithLogic = function TagDateInputWithLogic(_ref0) {
  var value = _ref0.value,
    onChange = _ref0.onChange,
    field = _ref0.field,
    _ref0$className = _ref0.className,
    className = _ref0$className === void 0 ? "" : _ref0$className,
    _ref0$inputClassName = _ref0.inputClassName,
    inputClassName = _ref0$inputClassName === void 0 ? "" : _ref0$inputClassName,
    logic = _ref0.logic,
    onLogicChange = _ref0.onLogicChange,
    disabled = _ref0.disabled,
    textColor = _ref0.textColor,
    borderColor = _ref0.borderColor,
    isLC = _ref0.isLC;
  var isDisabled = disabled !== undefined ? disabled : !field.additional.isEditable;
  var comparisonOptions = getLogicOptions("date");
  var selectedLogicOption = comparisonOptions.find(function (opt) {
    return opt.value === logic;
  }) || comparisonOptions[0];

  // Ensure value is properly formatted for DateRangeInput when logic is "between"
  var getFormattedValue = function getFormattedValue() {
    if (logic === "between") {
      // If value is already an array, use it; otherwise create an array with the value
      if (Array.isArray(value)) {
        // Ensure both dates are properly converted to Date objects or null
        return value.map(function (date) {
          if (date === null || date === undefined) return null;
          try {
            // If date is already a string in YYYY-MM-DD format, create Date object
            if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
              return new Date(date + "T00:00:00Z"); // Force UTC to avoid timezone issues
            }
            return new Date(date);
          } catch (error) {
            return null;
          }
        });
      }
      // If value is a single date (string or Date object), create an array with that date
      if (value) {
        try {
          var dateObj;
          // If value is a string in YYYY-MM-DD format, create Date object
          if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
            dateObj = new Date(value + "T00:00:00Z"); // Force UTC to avoid timezone issues
          } else {
            dateObj = new Date(value);
          }
          return [dateObj, null];
        } catch (error) {
          console.error("Error while creating date object:    ", error);
          return [null, null];
        }
      }
      // If value is null, undefined, or falsy, return an array with null values
      return [null, null];
    }
    return value;
  };

  // Handle onChange for DateRangeInput to ensure parent receives correct format
  var handleDateRangeChange = function handleDateRangeChange(dateRangeValue) {
    // Helper function to convert Date to YYYY-MM-DD format (same as TagDateInput)
    var normalizeDate = function normalizeDate(date) {
      if (!date) return null;
      // Convert to YYYY-MM-DD format to match TagDateInput behavior
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    if (logic === "between") {
      // For "between" logic, normalize both dates to YYYY-MM-DD format
      var normalizedRange = dateRangeValue.map(normalizeDate);
      onChange(normalizedRange);
    } else {
      // For other logic types, normalize the first date to YYYY-MM-DD format
      var normalizedDate = normalizeDate((dateRangeValue === null || dateRangeValue === void 0 ? void 0 : dateRangeValue[0]) || null);
      onChange(normalizedDate);
    }
  };
  var getPlaceholderText = function getPlaceholderText() {
    if (Array.isArray(value) && value.some(function (d) {
      return d;
    })) {
      var formatted = value.map(function (d) {
        if (!d) return "";
        try {
          // If date is already a string in YYYY-MM-DD format, format it directly
          if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
            return format(new Date(d + "T00:00:00Z"), "MMM d, yyyy");
          }
          return format(new Date(d), "MMM d, yyyy");
        } catch (error) {
          return "";
        }
      }).join(" - ");
      if (formatted.startsWith(" - ")) return formatted.substring(3);
      if (formatted.endsWith(" - ")) return formatted.substring(0, formatted.length - 3);
      return formatted;
    }
    if (!Array.isArray(value) && value) {
      try {
        // If value is a string in YYYY-MM-DD format, format it directly
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return format(new Date(value + "T00:00:00Z"), "MMM d, yyyy");
        }
        return format(new Date(value), "MMM d, yyyy");
      } catch (error) {
        return field.tag;
      }
    }
    return field.tag;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 w-full ".concat(className)
  }, /*#__PURE__*/React.createElement(Dropdown, {
    selectedOption: selectedLogicOption,
    onChange: function onChange(option) {
      return onLogicChange === null || onLogicChange === void 0 ? void 0 : onLogicChange(option.value);
    },
    options: comparisonOptions,
    disabled: isDisabled,
    isBottomAligned: true,
    hasBorder: true,
    className: "border w-full !px-2 !py-2 ".concat(borderColor && !isLC ? borderColor.replace("border-", "!border-") : "!border-gray-400")
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 ".concat(!logic ? "opacity-50 pointer-events-none" : "", " w-full")
  }, logic === "between" ? /*#__PURE__*/React.createElement(DateRangeInput, {
    value: getFormattedValue(),
    onChange: handleDateRangeChange,
    tooltip: getPlaceholderText(),
    placeholder: field.tag,
    classNames: "w-full",
    inputFormat: "MMM DD, YYYY",
    highlightToday: true
  }) : /*#__PURE__*/React.createElement(TagDateInput, {
    value: value,
    onChange: onChange,
    field: field,
    className: "".concat(inputClassName, " !w-full"),
    disabled: isDisabled
  })));
};

// Custom hook for calculating option width
var useOptionWidthCalculation = function useOptionWidthCalculation(options) {
  var minWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
  var _useState = useState(0),
    maxOptionWidth = _useState[0],
    setMaxOptionWidth = _useState[1];
  var hiddenSpanRef = useRef(null);
  useEffect(function () {
    if (hiddenSpanRef.current && options.length > 0) {
      var span = hiddenSpanRef.current;
      var maxWidth = 0;

      // Test each option to find the longest one
      options.forEach(function (option) {
        span.textContent = option;
        var width = span.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      // Add padding for the button (px-5 = 20px, pr-7 = 28px, plus some buffer for the dropdown arrow)
      var buttonPadding = 60;
      var calculatedWidth = maxWidth + buttonPadding + 10;

      // Ensure minimum width and apply the calculated width
      setMaxOptionWidth(Math.max(calculatedWidth, minWidth));
    }
  }, [options, minWidth]);
  return {
    maxOptionWidth: maxOptionWidth,
    hiddenSpanRef: hiddenSpanRef
  };
};